import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["error"]

  connect() {
    this.touched = false
    this.input = this.element.querySelector("input, select, textarea")
    if (!this.input) return

    this.input.addEventListener("blur", this.onBlur.bind(this))
    this.input.addEventListener("input", this.onInput.bind(this))
  }

  disconnect() {
    if (!this.input) return
    this.input.removeEventListener("blur", this.onBlur.bind(this))
    this.input.removeEventListener("input", this.onInput.bind(this))
  }

  onBlur() {
    this.touched = true
    this.validate()
  }

  onInput() {
    if (this.touched) this.validate()
  }

  validate() {
    const valid = this.input.checkValidity()
    this.input.classList.toggle("border-danger-500", !valid)
    this.input.classList.toggle("border-neutral-200", valid)
    this.input.setAttribute("aria-invalid", String(!valid))

    if (this.hasErrorTarget) {
      this.errorTarget.classList.toggle("hidden", valid)
    }
  }
}
